import React, { ChangeEvent, FC } from 'react';
import { FiAlertCircle, FiX } from 'react-icons/fi';
import { TCheckDynamicCatalogDataResult } from 'domains/ReportBuilder/types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import css from '../../styles.module.scss';

interface IInputAreaProps {
  value: string[];
  onClose: () => void;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  notExistKeys: TCheckDynamicCatalogDataResult | null;
}

const InputArea: FC<IInputAreaProps> = ({
  value,
  onClose,
  onChange,
  notExistKeys,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className={cn(css.input, {
          _isHasErrorKeys: !!notExistKeys?.length,
        })}
      >
        <div className={css.input__header}>
          <div className={css.input__title}>
            <FiAlertCircle />
            <span>{t(`reportbuilder.pressEnter`)}</span>
          </div>
          <div className={css.input__close}>
            <FiX onClick={onClose} />
          </div>
        </div>
        <div className={css.input__content}>
          <textarea
            placeholder={t(`campaigns_page.create_campaign.enter`)}
            value={value.join(',')}
            onChange={onChange}
          />
        </div>
      </div>
      {!!notExistKeys?.length && (
        <div className={css.input__error}>
          <span>{t(`reportbuilder.invalidKeys`)} </span>
          {notExistKeys.map((key, index) => (
            <React.Fragment key={key}>
              {key}

              {index < notExistKeys.length - 1 && ', '}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
};

export default InputArea;
